import React from 'react'
import { BrowserRouter } from 'react-router'
import { createRoot } from 'react-dom/client'
import { App } from './App'

import '@fontsource/open-sans'
import '@fontsource/lora'

const root = createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)
